import axios, { CancelTokenSource } from 'axios';
import { useRef, useState, useEffect, ReactElement } from 'react';
import { useGlobalState, setGlobalState } from '../../state/state';
import { sources } from '../../api/sources';
import { buildCostCalculatorRequest } from '../../state/helpers';
import { Pages, SESSION_EXPIRED_STATUS_CODES } from '../../utils/constants';
import { useHistory } from 'react-router-dom';

export const COST_CALCULATOR_CANCEL_MESSAGE = 'Canceling price cart update';

export interface ICostCalculatorProviderProps {
  children: ReactElement;
}

export const CostCalculatorProvider = (props: ICostCalculatorProviderProps) => {
  const history = useHistory();
  const hasFormDataInitialized = useRef(false);
  const [formData] = useGlobalState('formData');
  const [memberDetails] = useGlobalState('memberDetails');
  const [priceCartCancelTokenSource, setPriceCartCancelTokenSource] = useState(null as null | CancelTokenSource);

  const callCostCalculator = async () => {
    if (priceCartCancelTokenSource) {
      priceCartCancelTokenSource.cancel(COST_CALCULATOR_CANCEL_MESSAGE);
    }

    const source = axios.CancelToken.source();
    setPriceCartCancelTokenSource(() => source);

    setGlobalState('loading', (prev) => ({ ...prev, priceCart: true }));
    const cancelToken = source.token;
    const request = buildCostCalculatorRequest(formData, memberDetails);
    // const { additionalDiscounts, prospectiveCosts, priceCart, status, error } = await sources.calculateCost(
    const response = await sources.calculateCost(request, cancelToken);

    if (response.status === 'cancel') {
      return;
    } else if (response.status !== 'error') {
      const { additionalDiscounts, prospectiveCosts, priceCart, status } = response;
      setGlobalState('additionalDiscounts', () => additionalDiscounts);
      setGlobalState('prospectiveCosts', () => prospectiveCosts);
      setGlobalState('priceCart', () => priceCart);
      setGlobalState('loading', (prev) => ({ ...prev, priceCart: false }));
      setPriceCartCancelTokenSource(() => null);
    } else {
      // @ts-ignore
      const timeoutError = SESSION_EXPIRED_STATUS_CODES.includes(response?.error?.code);
      if (timeoutError) {
        history.push(Pages.TimeoutError);
      } else {
        history.push(Pages.SorryPage);
      }
    }
  };

  useEffect(() => {
    if (window.location.pathname === `/membership/selfservice${Pages.MaintenancePage}`) {
      return;
    }
    const currentPage = window.location.pathname.replace('/membership/selfservice', '') as Pages;
    const nonCostCalculatorPages = [Pages.UpdateMembershipStatusPage, Pages.ConfirmationPage, Pages.SorryPage];
    const isNonCostCalculatorPage = nonCostCalculatorPages.includes(currentPage);

    if (isNonCostCalculatorPage || !formData.requestedBillPlan || !memberDetails.sessionId) {
      return;
    }

    callCostCalculator();

    // if (hasFormDataInitialized.current) {
    //   callCostCalculator();
    // } else {
    //   hasFormDataInitialized.current = true;
    // }
  }, [formData]);

  return <>{props.children}</>;
};
